<div class="tab-box">
    <div class="title-ind">
      <h1 class="title-tab">Licencias</h1>
    </div>
    <div class="acciones-tabla">
      <!-- <app-input-tabla (keyup)="applyFilter($event)"></app-input-tabla> -->
      <div>
        <!-- <app-nueva-entidad (click)="openDialog()"></app-nueva-entidad> -->
        <app-descargar (click)="exportAsExcel()"></app-descargar>
      </div>
    </div>
    <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
      <ng-container matColumnDef="id">
        <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>
          ID
        </th>
        <td mat-cell *matCellDef="let licencia">{{ licencia.IDLicencia }}</td>
      </ng-container>
      <ng-container matColumnDef="cliente">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>CLIENTE</th>
        <td mat-cell *matCellDef="let licencia">{{ licencia.cliente?.nombreComercial }}</td>
      </ng-container>
      <ng-container matColumnDef="centro">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>CENTRO</th>
        <td mat-cell *matCellDef="let licencia">{{ licencia.centro?.nombre }}</td>
      </ng-container>
      <ng-container matColumnDef="fecha confirmacion">
        <th color="primary" mat-header-cell *matHeaderCellDef mat-sort-header>
          FECHA ACTIVACIÓN
        </th>
        <td mat-cell *matCellDef="let licencia">{{ licencia.fechaConfirmacion | date:'dd/MM/YYYY'}}</td>
      </ng-container>
      <ng-container matColumnDef="fecha caducidad">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>FECHA DE CADUCIDAD</th>
        <td mat-cell *matCellDef="let licencia">{{ licencia.fechaCaducidad | date:'dd/MM/YYYY'}}</td>
      </ng-container>
      
      
     <!--  <ng-container matColumnDef="acciones">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>ACCIONES</th>
        <td mat-cell *matCellDef="let licencia">
          <ng-container *ngIf="dateRenovacion(licencia.fechaRenovacion)">
            <div>
            <p (click)="openDialog(licencia)" class= "pago-tabla"> Renovar </p>
            
            </div>
          </ng-container>
          <ng-container *ngIf="!dateRenovacion(licencia.fechaRenovacion)" > 
              <div>
            <p class= "pago-tabla"> Renovariii </p>
          </div>  
          </ng-container>
        </td>
      </ng-container> -->
      
      <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[10, 15, 20]"></mat-paginator>
  </div>
